import { render, staticRenderFns } from "./LocaleType.vue?vue&type=template&id=13bec830&scoped=true"
import script from "./LocaleType.vue?vue&type=script&lang=js"
export * from "./LocaleType.vue?vue&type=script&lang=js"
import style0 from "./LocaleType.vue?vue&type=style&index=0&id=13bec830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bec830",
  null
  
)

export default component.exports